import type { RequestCompletionModeResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { requestKeys } from "@/hooks/queryKeys";
import { useGetRequest } from "@/hooks/useGetRequest.tsx";
import apiClient from "@/lib/api/client";

export function useCompletionMode(enabled: boolean) {
  const { data: request } = useGetRequest();
  const requestId = request?.id;

  return useQuery<RequestCompletionModeResponse>({
    enabled: enabled && !!requestId,
    gcTime: 0,
    queryFn: () =>
      apiClient.url(`/requests/${requestId}/completion-mode`).get().json(),
    queryKey: requestKeys.completionMode(Number(requestId)),
    staleTime: 0,
  });
}
